import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";
import { Link, withRouter } from "react-router-dom";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
    this.uploadList = this.uploadList.bind(this);
  }
  componentDidMount() {
    this.uploadList();
  }

  uploadList = (date) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      "https://dwltnlb3hto3i.cloudfront.net/v1/banner/detail",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          ref.setState(
            {
              items: result.response,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      })
      .catch((error) => console.log("error", error));
  };

  goToUpdatePage = (id) => {
    this.props.history.push(`/vocalforlocal/upload/${id}`);
  };

  render() {
    var bread = "Vocal For Local / Upload List";
    var items = this.state.items;
    console.log("item", items);
    var type = this.state.type;
    return (
      <div>
        <PageTitle title="#Vocal For Local" bread={bread} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      <th>Id</th>
                      <th>Image</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {Array.isArray(items) &&
                      items.map((value, index) => {
                        return ( */}
                    <tr>
                      <td>{items.id ? items.id : "null"}</td>
                      <td>
                        <img
                          width="200"
                          height="100"
                          src={items.banner_path}
                          alt="media"
                        />
                      </td>
                      <td>{items.created_at}</td>
                      <td>
                        <button
                          className="btn btn-primary btn-rounded"
                          onClick={() => this.goToUpdatePage(items.id)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                    {/* );
                      })} */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/Components/VocalForLocal/UplaodList.jsx